import React, { useState, useEffect } from 'react';
import { downloadOrdenFile, previewOrdenFile } from '../../helpers/UploadFile';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useObtenerOrdenPorID } from '../../hooks/CuentasCobrarHook';

type Props = {
  id: number;
};

const View: React.FC<Props> = ({ id }) => {
  const history = useHistory();
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { ordenCobro } = useObtenerOrdenPorID(Number(id));

  const { nombre } = ordenCobro;

  useEffect(() => {
    const fetchPdf = async () => {
      const url = await previewOrdenFile(id);
      const pdf = URL.createObjectURL(url);
      setPdfUrl(pdf);
    };
    fetchPdf();
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [id]);

  return (
    <div>
      {pdfUrl ? (
        <>
          <div className="card mb-6 mb-xl-9">
            <div className="card-body">
              <div className="row">
                <embed
                  src={`${pdfUrl}#toolbar=0`}
                  width="100%"
                  height="600px"
                  title="PDF Viewer"
                />
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="d-flex justify-content-end">
                    <button
                      type="reset"
                      className="btn btn-light me-3"
                      data-kt-users-modal-action="cancel"
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      onClick={(event) => {
                        setLoading(true);
                        downloadOrdenFile(id, nombre, event)
                          .then(() => {
                            setLoading(false);
                            toast.success(`Descarga del documento exitosa.`, {
                              position: 'top-right',
                              autoClose: 3000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                              theme: 'light',
                            });
                            history.goBack();
                          })
                          .catch((err) => {
                            let resMessageToast: string = '';
                            const {
                              data: { message, details = null },
                            } = err.response;
                            resMessageToast = `${message}`;
                            setLoading(false);
                            toast.error(resMessageToast, {
                              position: 'top-right',
                              autoClose: 4000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                              theme: 'light',
                            });
                          });
                      }}
                      className="btn btn-primary me-7"
                      data-kt-users-modal-action="submit"
                      disabled={loading}
                    >
                      {!loading && (
                        <span className="indicator-label">Descargar</span>
                      )}
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: 'block' }}
                        >
                          Espere por favor...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <span className="indicator-progress" style={{ display: 'block' }}>
          Espere por favor...
          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      )}
    </div>
  );
};

export { View };
